export const RECORDS_DB_STATS = 'RECORDS_DB_STATS';
export const RECORDS_DB_ACTIVITY = 'RECORDS_DB_ACTIVITY';
export const LAST_ACTIVITY_DATA='LAST_ACTIVITY_DATA';
export const RECORDS_DASHBOARD_LOADER = 'RECORDS_DASHBOARD_LOADER';
export const FILE_DASHBOARD_LOADER='FILE_DASHBOARD_LOADER';
